

import {GoCheck} from "react-icons/go"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import {MdKeyboardArrowRight} from "react-icons/md"
import { handleActiveSelect } from "../../../../../../features/layout/layoutSlice"
import { updateRouteItem } from "../../../../../../features/updateLoad/updateLoadSlice"

const Container = styled.div`
    width: 240px;
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;

    .btn{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        padding-right: 30px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme, isActive}) => isActive? "#E85446" : theme.mainBorderColor};
        border-bottom: 1px solid ${({theme}) => theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        border-bottom-left-radius: ${({isActive}) => isActive && 0};
        border-bottom-right-radius: ${({isActive}) => isActive && 0};
        color: var(--color-dark);
        background-color: ${({theme}) => theme.mainBgColor};
        text-align: start;
        font-size:10px;

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    label{
        position: absolute;
        transform: ${({focused}) => focused ? "translateY(-22px)" : "translateY(0)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, focused}) => focused ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }

    .arr-icon{
        position: absolute;
        right: 5px;
        top: 8px;
        transform: ${({isActive}) => isActive ? "rotate(90deg)": "rotate(0)"};
        font-size: 1.6rem;
        transition: .3s;
    }

    .options{
        position: absolute;
        top: 40px;
        background-color: ${({theme}) => theme.mainBgColor};
        display: flex;
        flex-direction: column;
        z-index: 10;
        width: 100%;
        border: 1px solid ${({theme, isActive}) => isActive? "#E85446" : theme.mainBorderColor};
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;

        .option{
            width: 100%;
            padding: 9px 20px;
            cursor: pointer;
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            display: flex;
            align-items: center;
            gap: 5px;

            &:hover{
                background-color: ${({theme}) => theme.secondaryBgColor};
            }


            .box{
              width: 22px;
              height: 22px;
              border-radius: 3px;
              border: 2px solid ${({theme}) => theme.mainTextColor};

              display: flex;
              justify-content: center;
              align-items: center;

              .check-icon{
                  font-size: 1.2rem;
                  color:#000;
              }

            }

          .label{
              font-size: 12px;
              font-weight: var(--font-weight-xl);
          }
        }
    }

`

const BosaltmaBicimiInput = ({data, isRequired, labelText="Boşaltma Biçimi Seçiniz", name}) => {

    const dispatch = useDispatch()

    const {activeSelect} = useSelector(state => state.layout)

    const [focused, setFocused] = useState(false)

    const handleOptionClick = (itemIndex) => {

        const updatedSevkBicimleri = data.sevkBicimleri.map((item, i) => {
            if(itemIndex === i){
                return {...item, status:!item.status}
            }
            else{
                return item
            }
        })

        dispatch(updateRouteItem({id: data.id, sevkBicimleri: updatedSevkBicimleri}))
        // dispatch(handleActiveSelect(null))
    }

    //! active olan item ın arka planını hafif sarı yaparsın

  return (
    <Container onClick={(e)=>e.stopPropagation()} radius={"5px"} isActive={activeSelect === name} focused={focused || (activeSelect === name || data.sevkBicimleri.filter(item => item.status).length > 0)}>
        <button className="btn" onFocus={() => setFocused(true)} onBlur={() => setFocused(false)} onClick={() => dispatch(handleActiveSelect(name))}>{data.sevkBicimleri.filter(item => item.status).map((item) => <span>{item.name + ","}</span>)}</button>
        <label htmlFor={"text"}>{labelText}{isRequired && "*"}</label>
        <MdKeyboardArrowRight className="arr-icon"/>
            {
                activeSelect === name &&
                <div className="options" onClick={(e) => e.stopPropagation()}>
                    {
                        data.sevkBicimleri.map((item, i) => (
                          <div key={item.id} className="option" onClick={() => handleOptionClick(i)}>
                              <div className="box">{item.status && <GoCheck className="check-icon"/>}</div>
                              <div className="label">{item.name}</div>
                          </div>
                        ))
                    }
                </div>
            }
    </Container>
  )
}

export default BosaltmaBicimiInput